"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_1 = require("@mdi/js");
var react_1 = __importDefault(require("@mdi/react"));
var react_2 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var uuid_1 = require("uuid");
var __1 = require("../..");
var chatStyles_1 = require("../styles/chatStyles");
var Chat = function (_a) {
    var convo = _a.convo, back = _a.back, holeCoords = _a.holeCoords, setHoleCoords = _a.setHoleCoords;
    var _b = (0, react_2.useState)(false), eloiseTyping = _b[0], setEloiseTyping = _b[1];
    var _c = (0, __1.useEloise)(), logic = _c.logic, siteConfig = _c.siteConfig, theme = _c.theme, eloiseContent = _c.eloiseContent;
    var _d = (0, react_2.useState)([]), messages = _d[0], setMessages = _d[1];
    var _e = (0, react_2.useState)(""), input = _e[0], setInput = _e[1];
    var messagesEndRef = (0, react_2.useRef)(null);
    var _f = (0, react_2.useState)(logic.fb.getAuthenticatedUserUid()), uid = _f[0], setUID = _f[1];
    var squareSize = 100;
    var targetCoords = {
        top: (window.innerHeight - squareSize) / 2,
        right: (window.innerWidth + squareSize) / 2,
        bottom: (window.innerHeight + squareSize) / 2,
        left: (window.innerWidth - squareSize) / 2,
    };
    logic.hooks.useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var test2, ots;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(convo.id === "eloise")) return [3 /*break*/, 1];
                    setMessages([{ role: "assistant", content: "Hi how can I help?" }]);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, logic.fb.docs.getUserCollection("convos/" + convo.id + "/messages")];
                case 2:
                    test2 = _a.sent();
                    ots = test2.map(function (message) { return message.data; });
                    setMessages(ots);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    function formatEloiseIntelData(data) {
        var formattedData = data.map(function (item) {
            var id = item.id, position = item.position, rest = __rest(item, ["id", "position"]);
            var lines = " \n\n ".concat(Object.entries(rest)
                .map(function (_a) {
                var key = _a[0], value = _a[1];
                return "".concat(key, ": ").concat(value);
            })
                .join("\n"));
            return lines;
        });
        var semi = formattedData.join("\n\n");
        return "Content on Page: ".concat(semi);
    }
    var scrollToBottom = function () {
        var _a;
        (_a = messagesEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
    };
    (0, react_2.useEffect)(function () {
        scrollToBottom();
    }, [messages]);
    var handleSendMessage = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var prompt_1, test_1, newId, newMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setInput("");
                    e.preventDefault();
                    if (input.trim() === "")
                        return [2 /*return*/];
                    if (!(convo.id === "eloise")) return [3 /*break*/, 2];
                    setMessages(__spreadArray(__spreadArray([], messages, true), [
                        { role: "user", content: input },
                    ], false));
                    setEloiseTyping(true); // Eloise is typing
                    prompt_1 = formatEloiseIntelData(eloiseContent);
                    return [4 /*yield*/, logic.apiCall("siteChat", {
                            convo: __spreadArray(__spreadArray([], messages, true), [
                                { role: "user", content: prompt_1 },
                                { role: "user", content: input },
                            ], false),
                        }, siteConfig.eloiseConfig.endPoint)];
                case 1:
                    test_1 = _a.sent();
                    setMessages(__spreadArray(__spreadArray([], messages, true), [
                        { role: "user", content: input },
                        test_1,
                    ], false));
                    setEloiseTyping(false);
                    _a.label = 2;
                case 2:
                    newId = (0, uuid_1.v4)();
                    logic.fb.docs.setUserDoc("convos/" + convo.id + "/messages/" + newId, {
                        content: input,
                        senderId: uid,
                    });
                    if (convo.id !== "eloise") {
                        newMessage = { content: input, senderId: uid, id: newId };
                        setMessages(__spreadArray(__spreadArray([], messages, true), [newMessage], false));
                        logic.fb.docs.setOtherUserDoc("convos/" + convo.id + "/messages/" + newId, {
                            content: input,
                            senderId: uid,
                        }, convo.connectedTo);
                    }
                    setInput("");
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_2.default.createElement(chatStyles_1.ChatContainer, null,
        react_2.default.createElement("div", { style: {
                position: "absolute",
                top: "10px",
                left: "10px",
            }, onClick: function () { return back(); } },
            react_2.default.createElement(react_1.default, { path: js_1.mdiArrowLeft, size: 1, color: theme.colors[0] })),
        messages && (react_2.default.createElement(chatStyles_1.MessagesContainer, null,
            messages && (react_2.default.createElement(chatStyles_1.MessagesContainer, null,
                messages.map(function (message) {
                    var isUserMessage = "senderId" in message
                        ? message.senderId === uid
                        : message.role === "user";
                    var messageStyle = isUserMessage
                        ? chatStyles_1.userMessageStyle
                        : chatStyles_1.otherMessageStyle;
                    return (react_2.default.createElement(chatStyles_1.MessageWrapper, { key: (0, uuid_1.v4)(), style: messageStyle },
                        react_2.default.createElement(chatStyles_1.MessageContent, null, message.content)));
                }),
                eloiseTyping && convo.id === "eloise" && react_2.default.createElement(TypingIndicator, null),
                react_2.default.createElement("div", { ref: messagesEndRef }))),
            react_2.default.createElement("div", { ref: messagesEndRef }))),
        react_2.default.createElement(chatStyles_1.InputContainer, null,
            react_2.default.createElement(react_bootstrap_1.Form, { onSubmit: handleSendMessage },
                react_2.default.createElement(react_bootstrap_1.Form.Group, { className: "d-flex" },
                    react_2.default.createElement(react_bootstrap_1.FormControl, { value: input, onChange: function (e) { return setInput(e.target.value); }, placeholder: "Type your message..." }),
                    react_2.default.createElement(react_bootstrap_1.Button, { type: "submit", className: "ml-2" }, "Send"))))));
};
exports.default = Chat;
var TypingIndicator = function () {
    var typingDotStyle = {
        backgroundColor: "#000",
        borderRadius: "50%",
        width: "6px",
        height: "6px",
        margin: "0 2px",
        animationName: "typing",
        animationDuration: "1.2s",
        animationIterationCount: "infinite",
        animationFillMode: "both",
    };
    var typingDot1Style = __assign(__assign({}, typingDotStyle), { animationDelay: "0s" });
    var typingDot2Style = __assign(__assign({}, typingDotStyle), { animationDelay: "0.2s" });
    var typingDot3Style = __assign(__assign({}, typingDotStyle), { animationDelay: "0.4s" });
    return (react_2.default.createElement("div", { style: {
            display: "flex",
            justifyContent: "flex-start",
            marginBottom: "8px",
        } },
        react_2.default.createElement("div", { style: typingDot1Style }),
        react_2.default.createElement("div", { style: typingDot2Style }),
        react_2.default.createElement("div", { style: typingDot3Style })));
};
